export default ({ big }) => [
  {
    title: 'Заголовок', value: big.fontFamily1, paramName: 'fontFamily1', parentName: 'big',
  },
  {
    title: 'Текст', value: big.fontFamily2, paramName: 'fontFamily2', parentName: 'big',
  },
];
